export default __webpack_public_path__ + "static/footer-background-73cd501171e40b7240f67dc617b6df16.png";